import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentStage } from "src/app/domain/models/DocumentStage";

@Injectable({providedIn: 'root'})
export abstract class DocumentStageGateway {
  abstract getAll(): Observable<DocumentStage[]>
}